import { operationV } from '../../hooks/useEscalation';
import { saveUrlEscalation } from '../../pages/Escalation/OtpNewFlow/escalationStorage';
import { saveContacts } from '../../pages/profile/personalData/CustomerDataStorage';

type EscalationDecision = { type: 'navigate' } | { type: 'contacts' } | { type: 'external' } | { type: 'none' };

export const getEscalationNavigation = ({
    escalationType,
    url,
    contacts,
}: {
    escalationType: string;
    url: string;
    contacts: string[];
}): EscalationDecision => {
    const currentOperation = operationV.find((item) => item.url === url);
    const hasOTP = currentOperation?.otp;
    const hasOBD = currentOperation?.obd;

    if (escalationType === 'OBD') {
        if (hasOBD) return { type: 'navigate' };
        if (hasOTP) {
            saveContacts(contacts);
            saveUrlEscalation(url + location.search);
            return { type: 'contacts' };
        }
    }

    if (escalationType === 'OTP') {
        if (hasOBD && !hasOTP) return { type: 'external' };
        if (hasOTP) {
            saveContacts(contacts);
            saveUrlEscalation(url + location.search);
            return { type: 'contacts' };
        }
    }

    if (escalationType === 'NONE') {
        if (!contacts || contacts.length <= 0) return { type: 'external' };
        if (hasOBD && !hasOTP) return { type: 'external' };
        if (hasOBD && hasOTP) {
            saveContacts(contacts);
            saveUrlEscalation(url + location.search);
            return { type: 'contacts' };
        }
        if (!hasOBD && hasOTP) {
            saveContacts(contacts);
            saveUrlEscalation(url + location.search);
            return { type: 'contacts' };
        }
    }

    return { type: 'none' };
};
